// react
import { ChangeEvent } from 'react';

// types
import { ExchangeRateByDate } from '../../../../@types';

// mui
import { Grid, InputAdornment, SelectChangeEvent } from '@mui/material';

// i18n
import { useTranslation } from 'react-i18next';

// components
import { Input } from '../../Input/Input';

export interface ExchangeRateProps {
	currencyBase: string;
	exchangeRate: ExchangeRateByDate;
	index: number;
	onChange?: (index: number, name: string, value: string | number) => void;
}

export const ExchangeRate = ({
	currencyBase,
	exchangeRate,
	index,
	onChange,
}: ExchangeRateProps) => {
	// i18n
	const { t } = useTranslation();

	// handlers
	const handleChangeValue = (e: ChangeEvent | SelectChangeEvent<unknown>) => {
		const { name, value } = e.target as HTMLInputElement;
		const nameNew = name.replace('[]', '');

		let valueNew: number | string = value;

		if (nameNew === 'exchangeRate') {
			valueNew = Number(value);
		}

		onChange?.(index, nameNew, valueNew);
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} md={6}>
				<Input
					currency={currencyBase}
					id={`exchangeRate-${exchangeRate.currency}`}
					inputProps={{
						step: '0.000001',
					}}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">1 {exchangeRate.currency} =</InputAdornment>
						),
					}}
					label={`${exchangeRate.currency} - ${currencyBase}`}
					name={`exchangeRate[]`}
					onChange={handleChangeValue}
					required
					type="number"
					value={exchangeRate.exchangeRate || ''}
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<Input
					id={`dateExchangeRate-${exchangeRate.currency}`}
					label={t('date')}
					name={`dateExchangeRate[]`}
					onChange={handleChangeValue}
					required
					type="date"
					value={exchangeRate.dateExchangeRate || ''}
				/>
			</Grid>
		</Grid>
	);
};
